<template>
    <article class="node node--type-lecture node--view-mode-teaser" @mouseleave="hideMenu()">
        <div class="lecture__wrapper">
            <div v-if="lecture.quickedit" class="contextual_container">
                <button class="qe-button" ref="button">Opcje konfiguracji</button>
                <ul ref="menu">
                    <li>
                    <a :href="'/node/' + lecture.id + '/edit'" >Edytuj</a>
                    </li>
                </ul>
            </div>
            <div class="lecture__thumbnail-wrapper">
                <div class="lecture__thumbnail">
                    <div class="field__item" v-if="lecture.image">
                        <img :src="lecture.image" :alt="lecture.title" />
                    </div>
                    <div class="lecture__play-button-wrapper">
                        <div class="lecture__play-button-body">
                            <div class="lecture__play-button-text">
                            VIDEO
                            </div>
                            <a class="lecture__play-button" :href="lecture.url" aria-label="Zobacz">
                                <i class="lecture__play-icon"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lecture__details-wrapper">
                <h2 class="lecture__title">
                    <a :href="lecture.url">
                    {{ lecture.title }}
                    </a>
                </h2>
                <div class="lecture__date">
                    {{ lecture.date }}
                </div>
                <div class="lecture__teaser">
                    {{ lecture.description }} 
                </div>
                <div class="lecture__authors">
                    {{ lecture.authors }}
                </div>
                <div class="lecture__button">
                    <a class="button" :href="lecture.url">{{ state.Drupal.t('See') }}</a>
                </div>
            </div>
        </div>    
    </article>
</template>

<script>
export default {
  name: 'Lecture',
  props: {
    lecture: {
      type: Object,
    },
    state: {
      type: Object,
    }
  },
  methods: {
    focusChanged(event) {
      if (this.lecture.quickedit) {
        let type = event.type;
        let target = event.target;
        if (target.nodeName == 'BUTTON' && target.classList.contains('qe-button') && type == 'focusin') {
          this.$refs.menu.classList.add('show');
        } else if (target.nodeName == 'BUTTON' && target.classList.contains('qe-button') && type == 'focusout') {
          if (event.explicitOriginalTarget.nodeValue != "Edytuj") {
            this.$refs.menu.classList.remove('show');
          } else {
            this.$refs.menu.classList.remove('show');
            event.explicitOriginalTarget.parentElement.click()
          }
        }
      }
    },
    hideMenu() {
      if (this.$refs.menu && this.$refs.menu.classList.contains('show')) {
        this.$refs.menu.classList.remove('show');
        this.$refs.button.blur();
      }
    }
  },
  created() {
    document.addEventListener('focusin', this.focusChanged)
    document.addEventListener('focusout', this.focusChanged)
  },
  beforeDestroy() {
    document.removeEventListener('focusin', this.focusChanged)
    document.removeEventListener('focusout', this.focusChanged)
  }
}
</script>
